class SalaDisputa {
  loading_opened = false;

  constructor(objParent) {
    this.objParent = objParent;
    this.lote_em_pregao_control = 0;
    this.db = objParent.firebase_db;
    this.lotesData = {};
    this.loteDataCount = 0;
    this.loteCountById = {};
    this.loteUltimoLanceKeyById = {};
    this.objParent.lotePregaoListeners = this.objParent.lotePregaoListeners || [];
  }

  acampanharLancesTelao(leilao_id, lote_id) {
    const self = this;

    self.db.ref(`/lance/${leilao_id}/${lote_id}`)
      .orderByChild("id")
      .once("value")
      .then((dados) => {
        self.objParent.$emit('lances', dados.val());
        self.objParent.lances = dados.val();
      })
  }

  /* atualiza lotes */
  async refreshLotesListagem(is_seguiremleilao = false) {
    const thisP = this.objParent;
    const self = thisP;
    const thisObj = this;
    let start = 1;

    const handleLotesData = (data, callback = null) => {
      let lotes = Object.values(data.val() || {});

      if (thisP.paginaAtual > 1) {
        start = (thisP.paginaAtual - 1) * thisP.numeroRegistrosPorPagina + 1;
      }

      self.lotes = lotes
        .sort((a, b) => a.seq - b.seq)
        .slice(start - 1, start - 1 + thisP.numeroRegistrosPorPagina)
        .map(lote => thisObj.vistoriaCampos(lote));

      if (callback)
        callback();
    };

    const configureLotes = () => {
      thisObj.observaLotesStatusLance(self.lotes);
      thisObj.configuraFavoritos();
      thisObj.configuraVisitas();
      self.actionSeguir();
      //thisP.stopLoading();
    };

    if (!is_seguiremleilao) {
      thisP.ordernar_por = 'seq';

      if (thisObj.refreshLotesDb) {
        thisObj.refreshLotesDb.off();
        thisObj.refreshLotesDb = null;
      }

      const currentPageIndex = Math.max(thisP.paginaAtual - 1, 0);
      const lotesToObserve = thisP.lotesAcompanhar.length > 0 ? thisP.lotesAcompanhar[currentPageIndex] : [];
      const lotesRef = thisObj.db.ref(`/lote/${thisP.leilaoId}`);

      // Busca a lista geral dos lotes ordenados
      await lotesRef.orderByChild(thisP.ordernar_por).once('value')
        .then(snapshot => {
          if (!snapshot.exists()) {
            return Promise.reject("Nenhum lote encontrado."); // Interrompe a execução
          }
          // Processa os dados da lista geral
          return new Promise(resolve => {
            handleLotesData(snapshot);
            resolve(); // Garante que continue após processar os dados
          });
        })
        .then(() => {
          // Agora busca os lotes observados
          return Promise.all(
            lotesToObserve.map(loteId => lotesRef.child(loteId).once('value'))
          );
        })
        .then(lotes => {
          if (thisP.leilao.leilao_id_primeiroleilao) {
            handleLinkedLeiloes(lotes, configureLotes);
          } else {
            configureLotes();
          }
        })
        .catch(error => console.error("Erro ao buscar lotes:", error));

    } else {
      thisP.ordernar_por = 'seq_dtfechamento';

      thisObj.refreshLotesDb = thisObj.db.ref(`/lote/${thisP.leilaoId}`)
        .orderByChild(thisP.ordernar_por)
        .equalTo(true);

      thisObj.refreshLotesDb.on('value', snapshot => {
        if (!snapshot.exists()) {
          self.lotes = null;
          return;
        }

        const lotesData = Object.values(snapshot.val() || {}).map(lote => thisObj.vistoriaCampos(lote));

        if (lotesData.length === 0) {
          self.lotes = null;
          return;
        }

        self.naoEncomtrado = false;
        self.lotes = lotesData;

        if (thisP.leilao.leilao_id_primeiroleilao) {
          handleLinkedLeiloes(self.lotes, configureLotes);
        } else {
          configureLotes();
        }
      }, error => console.error("Erro ao buscar lotes com seq_dtfechamento:", error));
    }

    async function handleLinkedLeiloes(lotes, callback = null) {
      const lotesAtual = lotes.map(lote => thisObj.vistoriaCampos(lote.val()));

      await thisObj.db.ref(`/lote/${thisP.leilao.leilao_id_primeiroleilao}`).once('value').then(data => {
        const lotesPrimeiroLeilao = Object.values(data.val() || {});

        const lotesVinculados = lotesAtual.map(loteAtual => {
          const matchingLote = lotesPrimeiroLeilao.find(lotePrimeiro =>
            thisObj.vistoriaCampos(lotePrimeiro).vistoria_id === loteAtual.vistoria_id
          );

          if (matchingLote) {
            loteAtual.primeiro_vistoria_vl_lanceinicial = matchingLote.vistoria_vl_lanceinicial;
          }

          return loteAtual;
        }).filter(Boolean);

        self.lotes = lotesVinculados;

        if (!lotesVinculados.length) {
          self.naoEncomtrado = true;
          return;
        }

        self.naoEncomtrado = false;
        if (callback)
          callback();
      });
    }
  }

  ordenaLotesPorSeq(lotes) {
    lotes.sort(function (a, b) {
      return a.seq - b.seq;
    });
  }

  carregaLoteEmPregao(lote_id_pregao, leilao_id) {
    const thisObj = this.objParent;
    const self = this;
    const requestKey = `${leilao_id}:${lote_id_pregao}`;

    if (
      thisObj.lotePregaoObservedKey === requestKey &&
      thisObj.lote_em_pregao &&
      thisObj.loteStatusReference
    ) {
      return;
    }

    thisObj.lotePregaoRequestKey = requestKey;

    if (thisObj.leilao.leilao_id_primeiroleilao) {
      self.db.ref(`/lote/${leilao_id}/${lote_id_pregao}`)
        .once("value")
        .then(function (data) {
          if (thisObj.lotePregaoRequestKey !== requestKey) {
            return;
          }

          if (data.val() == null) {
            thisObj.lote_em_pregao = self.vistoriaCampos(data.val());
            self.observaLotePregao(leilao_id, lote_id_pregao);
            return
          }

          const lotes_segundo_leilao = [];
          lotes_segundo_leilao.push(self.vistoriaCampos(data.val()));

          self.db.ref(`/lote/${thisObj.leilao.leilao_id_primeiroleilao}`).once("value", function (data) {
            if (thisObj.lotePregaoRequestKey !== requestKey) {
              return;
            }

            const lotes_primeiro_leilao = data.val();
            const lote_segundo_leilao = Object.keys(lotes_segundo_leilao).map((key) => {
              const vistoria_id_segundo_leilao = lotes_segundo_leilao[key].vistoria_id;

              // Lotes do primeiro leilao
              const lote_primeiro_leilao = Object.keys(lotes_primeiro_leilao).map((keyPrimeiro) => {
                const lotePerimeiro = self.vistoriaCampos(lotes_primeiro_leilao[keyPrimeiro]);
                const vistoria_id_primeiro_leilao = lotePerimeiro.vistoria_id;
                return (vistoria_id_primeiro_leilao == vistoria_id_segundo_leilao)
                  ? lotePerimeiro : false;
              }).filter((lote) => lote);

              // Pegando dados do primeiro leilao
              lotes_segundo_leilao[key].primeiro_vistoria_vl_lanceinicial = lote_primeiro_leilao[0].vistoria_vl_lanceinicial;
              return (lote_primeiro_leilao.length == 1) ? lotes_segundo_leilao[key] : false;
            }).filter((lote) => lote);

            thisObj.lote_em_pregao = lote_segundo_leilao[0];
            self.observaLotePregao(leilao_id, lote_id_pregao);
          })
        })
    } else {
      self.db.ref(`/lote/${leilao_id}/${lote_id_pregao}`)
        .once("value")
        .then(function (data) {
          if (thisObj.lotePregaoRequestKey !== requestKey) {
            return;
          }

          thisObj.lote_em_pregao = self.vistoriaCampos(data.val());
          self.observaLotePregao(leilao_id, lote_id_pregao);
        })
    }
  }

  vistoriaCampos(lote) {
    if (lote && typeof lote.dt_fechamento === 'undefined') {
      lote.dt_fechamento = null;
    }

    if (lote && lote.vistoria) {
      const self = this;

      lote.vistoria.forEach((vistoria) => {
        const valor1 = Number(vistoria.vl_lanceinicial) || 0;
        const valor2 = Number(vistoria.vl_lanceinicialsegundoleilao) || 0;

        lote.vistoria_vl_lanceinicial = 'R$ ' + self.formatPrice(valor1);
        lote.vistoria_vl_lanceinicialsegundoleilao = 'R$ ' + self.formatPrice(valor2);

        // Definir vistoria_id com base no primeiro identificador disponível
        lote.vistoria_id = vistoria.imovel_id || vistoria.veiculo_id || vistoria.equipamento_id || null;
      });
    }

    return lote;
  }


  formatPrice(price) {
    return parseFloat(price)
      .toFixed(2).replace('.', ',')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }

  setReactiveField(target, field, value) {
    if (!target) {
      return;
    }

    if (this.objParent && typeof this.objParent.$set === 'function') {
      this.objParent.$set(target, field, value);
      return;
    }

    target[field] = value;
  }

  getLotesAtualizar(lotes = null) {
    const thisP = this.objParent;

    return Array.isArray(lotes)
      ? lotes
      : (thisP && Array.isArray(thisP.lotes) ? thisP.lotes : []);
  }

  getLotesSincronizados(loteId, lotes = null) {
    if (!loteId) {
      return [];
    }

    const thisP = this.objParent;
    const loteIdString = String(loteId);
    const lotesAtualizar = this.getLotesAtualizar(lotes);
    const lote = lotesAtualizar.find(i => i && String(i.lote_id) === loteIdString);
    const lotesSincronizados = [];
    const lotePregao = (
      thisP &&
      thisP.lote_em_pregao &&
      typeof thisP.lote_em_pregao === 'object'
    )
      ? thisP.lote_em_pregao
      : null;

    if (lote && typeof lote === 'object') {
      lotesSincronizados.push(lote);
    }

    if (
      lotePregao &&
      lotePregao !== lote &&
      String(lotePregao.lote_id) === loteIdString
    ) {
      lotesSincronizados.push(lotePregao);
    }

    return lotesSincronizados;
  }

  atualizaDtFechamentoLote(loteId, dtFechamento, lotes = null) {
    if (!loteId) {
      return;
    }

    this.getLotesSincronizados(loteId, lotes).forEach((lote) => {
      this.setReactiveField(lote, 'dt_fechamento', dtFechamento || null);
    });
  }

  aplicaDadosLanceLote(lote, data) {
    if (!lote || !data) {
      return;
    }

    const thisP = this.objParent;
    const lanceAtual = parseFloat(data.vl);

    this.setReactiveField(lote, 'nm_usuario', data.nm_apelido);
    this.setReactiveField(lote, 'vl_lance', thisP.$root.formatarPreco(data.vl));

    if (lanceAtual <= 0) {
      let lanceSugerido = parseFloat(lote.vl_lanceinicial);
      if (lanceSugerido <= 0) {
        lanceSugerido = parseFloat(lote.raw_incremento);
      }

      this.setReactiveField(lote, 'vl_lance_sugerido', thisP.$root.formatarPreco(lanceSugerido));
    } else {
      this.setReactiveField(
        lote,
        'vl_lance_sugerido',
        thisP.$root.formatarPreco(lanceAtual + parseFloat(lote.raw_incremento))
      );
    }
  }

  atualizaDadosLanceLote(loteId, data, lotes = null) {
    if (!loteId || !data) {
      return;
    }

    this.getLotesSincronizados(loteId, lotes).forEach((lote) => {
      this.aplicaDadosLanceLote(lote, data);
    });
  }

  atualizaCountLancesLote(loteId, countLances, lotes = null) {
    if (!loteId) {
      return;
    }

    this.getLotesSincronizados(loteId, lotes).forEach((lote) => {
      this.setReactiveField(lote, 'count_lances', countLances);
    });
  }

  limpaLotePregaoReference() {
    this.objParent.lotePregaoRequestKey = null;
    this.objParent.lotePregaoObservedKey = null;
    this.objParent.lotePregaoObservedVersion = (this.objParent.lotePregaoObservedVersion || 0) + 1;
    this.removeLotePregaoListeners();

    [
      'loteStatusReference',
      'loteLanceReference',
      'loteLanceLastReference',
      'loteIncrementoReference',
      'loteDtfechamentoReference'
    ].forEach((referenceKey) => {
      this.objParent[referenceKey] = null;
    });
  }

  registraLotePregaoListener(ref, eventName, handler) {
    if (!ref || typeof ref.on !== "function" || typeof handler !== "function") {
      return;
    }

    this.objParent.lotePregaoListeners.push({ref, eventName, handler});
  }

  removeLotePregaoListeners() {
    const listeners = this.objParent.lotePregaoListeners || [];

    listeners.forEach(({ref, eventName, handler}) => {
      if (ref && typeof ref.off === "function") {
        ref.off(eventName, handler);
      }
    });

    this.objParent.lotePregaoListeners = [];
  }

  limpaLotePregaoAtualReference() {
    if (this.objParent.lotePregaoAtualReference && typeof this.objParent.lotePregaoAtualReference.off === "function") {
      this.objParent.lotePregaoAtualReference.off();
      this.objParent.lotePregaoAtualReference = null;
    }

    this.limpaLeilaoReference();
  }

  limpaLeilaoReference() {
    if (this.objParent.leilaoReference && typeof this.objParent.leilaoReference.off === "function") {
      this.objParent.leilaoReference.off();
      this.objParent.leilaoReference = null;
    }
  }

  limpaTipoParcelamentoReference() {
    if (this.objParent.tipoParcelamentoReference && typeof this.objParent.tipoParcelamentoReference.off === "function") {
      this.objParent.tipoParcelamentoReference.off();
      this.objParent.tipoParcelamentoReference = null;
    }
  }

  getUltimoLanceRegistro(data) {
    if (!data) {
      return null;
    }

    const entries = Object.entries(data);

    if (!entries.length) {
      return null;
    }

    const [key, value] = entries[entries.length - 1];

    return {key, value};
  }

  getUltimoLanceOrdenado(ref) {
    return ref.orderByChild("id")
      .limitToLast(1)
      .once("value")
      .then((snapshot) => this.getUltimoLanceRegistro(snapshot.val()));
  }

  atualizaLanceLotePregaoZerado(loteId) {
    this.atualizaLanceLotePregao({
      nm_apelido: null,
      vl: 0.0,
      lote_id: loteId
    }, loteId);
  }

  recarregaUltimoLancePregao(loteIdPregao, observedKey, observedVersion) {
    const thisObj = this.objParent;

    if (!thisObj.loteLanceReference) {
      return;
    }

    const loteId = typeof loteIdPregao !== 'undefined' ? loteIdPregao : thisObj.lote_id_pregao;

    thisObj.loteLanceReference
      .orderByChild("id")
      .limitToLast(1)
      .once("value")
      .then((snapshot) => {
        if (
          (observedKey && thisObj.lotePregaoObservedKey !== observedKey) ||
          (typeof observedVersion !== 'undefined' && thisObj.lotePregaoObservedVersion !== observedVersion)
        ) {
          return;
        }

        const ultimoRegistro = this.getUltimoLanceRegistro(snapshot.val());

        if (!ultimoRegistro) {
          this.loteUltimoLanceKeyById[loteId] = null;
          this.atualizaLanceLotePregaoZerado(loteId);
          return;
        }

        this.loteUltimoLanceKeyById[loteId] = ultimoRegistro.key;
        this.atualizaLanceLotePregao(ultimoRegistro.value, loteId);
      });
  }

  recarregaUltimoLanceLote(lotes, loteId, ref) {
    ref.orderByChild("id")
      .limitToLast(1)
      .once("value")
      .then((snapshot) => {
        const ultimoRegistro = this.getUltimoLanceRegistro(snapshot.val());

        if (!ultimoRegistro) {
          this.loteUltimoLanceKeyById[loteId] = null;
          this.atualizaLance(lotes, {
            nm_apelido: null,
            vl: 0.0,
            lote_id: loteId
          });
          return;
        }

        this.loteUltimoLanceKeyById[loteId] = ultimoRegistro.key;
        this.atualizaLance(lotes, ultimoRegistro.value, loteId);
      });
  }

  observaLotePregao(leilao_id, lote_id_pregao) {
    const thisObj = this.objParent;
    const self = this;
    const observedKey = `${leilao_id}:${lote_id_pregao}`;

    this.limpaLotePregaoReference();
    const observedVersion = (thisObj.lotePregaoObservedVersion || 0) + 1;
    thisObj.lotePregaoObservedKey = observedKey;
    thisObj.lotePregaoObservedVersion = observedVersion;

    const isLotePregaoAtual = () => (
      thisObj.lotePregaoObservedKey === observedKey &&
      thisObj.lotePregaoObservedVersion === observedVersion &&
      String(thisObj.lote_id_pregao) === String(lote_id_pregao) &&
      thisObj.lote_em_pregao
    );

    thisObj.loteStatusReference = self.db.ref(
      `/status/${leilao_id}/${lote_id_pregao}`
    );
    thisObj.loteLanceReference = self.db.ref(
      `/lance/${leilao_id}/${lote_id_pregao}`
    );
    thisObj.loteLanceLastReference = thisObj.loteLanceReference
      .orderByChild("id")
      .limitToLast(1);
    thisObj.loteIncrementoReference = self.db.ref(
      `/incremento/${leilao_id}/${lote_id_pregao}`
    );
    thisObj.loteDtfechamentoReference = self.db.ref(
      `/dtfechamento/${leilao_id}/${lote_id_pregao}`
    );

    /* status */
    const statusHandler = function (loteData) {
      if (!isLotePregaoAtual()) {
        return;
      }

      if (loteData.val()) {
        const data = loteData.val();
        if (data.lote_id == thisObj.lote_id_pregao) {
          thisObj.lote_em_pregao.liberado = false;

          thisObj.lote_em_pregao.statuslote = data.statuslote;
          thisObj.lote_em_pregao.statusLoteBg = data.statusLoteBg;
          self.setReactiveField(thisObj.lote_em_pregao, 'statuslote_id', data.statuslote_id);
          self.setReactiveField(thisObj.lote_em_pregao, 'statusliberacaolote_id', data.statusliberacaolote_id);
          thisObj.lote_em_pregao.liberado = true;

          if (data.statuslote_id == 15 || data.statuslote_id == 13 || data.statuslote_id == 10) {
            //Status Cancelado e Retirado, nao permitir enviar lance
            thisObj.lote_em_pregao.liberado = false;
          }

          if (data.statusliberacaolote_id != undefined) {
            if (data.statusliberacaolote_id != 2) {
              //Status Liberação (status de dentro do loteamento) só permitir lance se estiver como liberado
              thisObj.lote_em_pregao.liberado = false;
            }
          }
        }
      }
    };
    thisObj.loteStatusReference.on("value", statusHandler);
    self.registraLotePregaoListener(thisObj.loteStatusReference, "value", statusHandler);

    /* incremento */
    const incrementoHandler = function (loteData) {
      if (!isLotePregaoAtual()) {
        return;
      }

      if (loteData.val()) {
        const data = loteData.val();
        thisObj.lote_em_pregao.raw_incremento = data.raw_incremento;

        let lance = thisObj.lote_em_pregao.vl_lance
          .replace(/\./g, "")
          .replace(/R\$\s*/g, "")
          .replace(",", ".");

        lance = parseFloat(lance);
        if (lance <= 0) {
          let lancesugerido = parseFloat(
            thisObj.lote_em_pregao.vl_lanceinicial
          );
          if (lancesugerido <= 0) {
            lancesugerido = parseFloat(thisObj.lote_em_pregao.raw_incremento);
          }
          thisObj.lote_em_pregao.vl_lance_sugerido = thisObj.$root.formatarPreco(
            lancesugerido
          );
        } else {
          thisObj.lote_em_pregao.vl_lance_sugerido = thisObj.$root.formatarPreco(
            parseFloat(lance) +
            parseFloat(thisObj.lote_em_pregao.raw_incremento)
          );
        }
      }
    };
    thisObj.loteIncrementoReference.on("value", incrementoHandler);
    self.registraLotePregaoListener(thisObj.loteIncrementoReference, "value", incrementoHandler);

    /* lance */
    Promise.all([
      thisObj.loteLanceReference.once("value"),
      self.getUltimoLanceOrdenado(thisObj.loteLanceReference)
    ]).then(([snapshot, ultimoRegistro]) => {
      if (!isLotePregaoAtual()) {
        return;
      }

      const data = snapshot.val();
      const countLances = data ? Object.keys(data).length : 0;

      self.loteCountById[lote_id_pregao] = countLances;
      self.loteUltimoLanceKeyById[lote_id_pregao] = ultimoRegistro ? ultimoRegistro.key : null;
      self.atualizaCountLances(thisObj.lotes, {
        count_lances: countLances,
        lote_id: lote_id_pregao
      });

      if (ultimoRegistro) {
        self.atualizaLanceLotePregao(ultimoRegistro.value, lote_id_pregao);
      } else {
        self.atualizaLanceLotePregaoZerado(lote_id_pregao);
      }
    });

    const lanceAddedHandler = function (lanceData) {
      if (!isLotePregaoAtual()) {
        return;
      }

      const lanceKey = lanceData.key;

      if (self.loteUltimoLanceKeyById[lote_id_pregao] === lanceKey) {
        return;
      }

      self.loteUltimoLanceKeyById[lote_id_pregao] = lanceKey;
      self.loteCountById[lote_id_pregao] = (self.loteCountById[lote_id_pregao] || 0) + 1;
      self.atualizaCountLances(thisObj.lotes, {
        count_lances: self.loteCountById[lote_id_pregao],
        lote_id: lote_id_pregao
      });
      self.atualizaLanceLotePregao(lanceData.val(), lote_id_pregao);
    };
    thisObj.loteLanceLastReference.on("child_added", lanceAddedHandler);
    self.registraLotePregaoListener(thisObj.loteLanceLastReference, "child_added", lanceAddedHandler);

    const lanceChangedHandler = function (lanceData) {
      if (!isLotePregaoAtual()) {
        return;
      }

      self.loteUltimoLanceKeyById[lote_id_pregao] = lanceData.key;
      self.atualizaLanceLotePregao(lanceData.val(), lote_id_pregao);
    };
    thisObj.loteLanceLastReference.on("child_changed", lanceChangedHandler);
    self.registraLotePregaoListener(thisObj.loteLanceLastReference, "child_changed", lanceChangedHandler);

    const lanceRemovedHandler = function () {
      if (!isLotePregaoAtual()) {
        return;
      }

      const nextCount = Math.max((self.loteCountById[lote_id_pregao] || 0) - 1, 0);

      self.loteCountById[lote_id_pregao] = nextCount;
      self.atualizaCountLances(thisObj.lotes, {
        count_lances: nextCount,
        lote_id: lote_id_pregao
      });

      if (nextCount === 0) {
        self.loteUltimoLanceKeyById[lote_id_pregao] = null;
        self.atualizaLanceLotePregaoZerado(lote_id_pregao);
        return;
      }

      self.recarregaUltimoLancePregao(lote_id_pregao, observedKey, observedVersion);
    };
    thisObj.loteLanceReference.on("child_removed", lanceRemovedHandler);
    self.registraLotePregaoListener(thisObj.loteLanceReference, "child_removed", lanceRemovedHandler);

    /* Dt fechamento */
    const dtFechamentoHandler = function (loteData) {
      if (!isLotePregaoAtual()) {
        return;
      }

      if (loteData.val()) {
        const data = loteData.val();
        self.atualizaDtFechamentoLote(
          data.lote_id || lote_id_pregao,
          data.dt_fechamento,
          thisObj.lotes
        );
      } else {
        if (!thisObj.lote_em_pregao) {
          return
        }
        self.atualizaDtFechamentoLote(lote_id_pregao, null, thisObj.lotes);
      }
    };
    thisObj.loteDtfechamentoReference.on("value", dtFechamentoHandler);
    self.registraLotePregaoListener(thisObj.loteDtfechamentoReference, "value", dtFechamentoHandler);
  }

  /* limpa references */
  limpaLotesReference() {
    [
      'lotesStatusReference',
      'lotesLanceReference',
      'lotesLanceLastReference',
      'lotesIncrementoReference',
      'lotesDtfechamentoReference'
    ].forEach((referenceKey) => {
      (this.objParent[referenceKey] || []).forEach((ref) => {
        ref.off();
      });
      this.objParent[referenceKey] = [];
    });
  }

  /* observa status e ultimo lance dos lotes */
  async observaLotesStatusLance(lotes) {
    if (!lotes || Object.keys(lotes).length === 0) {
      return;
    }
    // clear all
    this.limpaLotesReference();
    const thisP = this.objParent;
    const self = this;
    this.lotesData = {};
    this.loteCountById = {};
    this.loteUltimoLanceKeyById = {};

    if (!thisP.lotesLanceLastReference) {
      thisP.lotesLanceLastReference = [];
    }

    for (const key in lotes) {
      const _lote = lotes[key];

      if (this.lotesData.hasOwnProperty(_lote.lote_id) == false) {
        this.lotesData[_lote.lote_id] = _lote;
        let loteRef = self.db.ref(`/lance/${_lote.leilao_id}/${_lote.lote_id}`);

        thisP.lotesStatusReference.push(
          self.db.ref(`/status/${_lote.leilao_id}/${_lote.lote_id}`)
        );
        thisP.lotesIncrementoReference.push(
          self.db.ref(`/incremento/${_lote.leilao_id}/${_lote.lote_id}`)
        );
        thisP.lotesDtfechamentoReference.push(
          self.db.ref(`/dtfechamento/${_lote.leilao_id}/${_lote.lote_id}`)
        );
        thisP.lotesLanceReference.push(loteRef);
        thisP.lotesLanceLastReference.push(
          loteRef.orderByChild("id").limitToLast(1)
        );

        Promise.all([
          loteRef.once("value"),
          self.getUltimoLanceOrdenado(loteRef)
        ]).then(([lancesData, ultimoRegistro]) => {
          const data = lancesData.val();
          const countLances = data ? Object.keys(data).length : 0;
          const loteId = _lote.lote_id;

          self.loteCountById[loteId] = countLances;
          self.loteUltimoLanceKeyById[loteId] = ultimoRegistro ? ultimoRegistro.key : null;
          const params = {
            count_lances: countLances,
            lote_id: loteId
          };

          self.atualizaCountLances(lotes, params);
        });
      }
    }

    /* status */
    thisP.lotesStatusReference.forEach(function (ref) {
      ref.on("value", (loteData) => {
        const data = loteData.val();

        if (!data) {
          return;
        }

        const idx = lotes.findIndex(i => i.lote_id == data.lote_id);

        if (idx !== -1) {
          lotes[idx].statuslote = data.statuslote;
          lotes[idx].statusLoteBg = data.statusLoteBg;
          self.setReactiveField(lotes[idx], 'statuslote_id', data.statuslote_id);
          self.setReactiveField(lotes[idx], 'statusliberacaolote_id', data.statusliberacaolote_id);
          lotes[idx].liberado = true;

          if (data.statuslote_id == 15 || data.statuslote_id == 13 || data.statuslote_id == 10) {
            lotes[idx].liberado = false;
          }

          if (data.statusliberacaolote_id != undefined) {
            if (data.statusliberacaolote_id != 2) {
              lotes[idx].liberado = false;
            }
          }
        }
      });
    });

    /* incremento */
    thisP.lotesIncrementoReference.forEach(function (ref) {
      ref.on("value", function (loteData) {
        const data = loteData.val();
        const idx = lotes.findIndex(i => i.lote_id == data.lote_id);

        if (idx !== -1) {
          lotes[idx].raw_incremento = data.raw_incremento;

          let lance = lotes[idx].vl_lance
            .replace(/\./g, "")
            .replace(/R\$\s*/g, "")
            .replace(",", ".");

          lance = parseFloat(lance);
          if (lance <= 0) {
            let lancesugerido = parseFloat(lotes[idx].vl_lanceinicial);
            if (lancesugerido <= 0) {
              lancesugerido = parseFloat(lotes[idx].raw_incremento);
            }
            lotes[idx].vl_lance_sugerido = thisP.$root.formatarPreco(lancesugerido);
          } else {
            lotes[idx].vl_lance_sugerido = thisP.$root.formatarPreco(
              parseFloat(lance) + parseFloat(lotes[idx].raw_incremento)
            );
          }
        }
      });
    });

    /* lance */
    thisP.lotesLanceLastReference.forEach(function (ref) {
      ref.on("child_added", function (lanceData) {
        const loteId = ref.ref.key;

        if (self.loteUltimoLanceKeyById[loteId] === lanceData.key) {
          return;
        }

        self.loteUltimoLanceKeyById[loteId] = lanceData.key;
        self.loteCountById[loteId] = (self.loteCountById[loteId] || 0) + 1;
        self.atualizaCountLances(lotes, {
          count_lances: self.loteCountById[loteId],
          lote_id: loteId
        });
        self.atualizaLance(lotes, lanceData.val(), loteId);
      });
    });

    thisP.lotesLanceLastReference.forEach(function (ref) {
      ref.on("child_changed", function (lanceData) {
        const loteId = ref.ref.key;

        self.loteUltimoLanceKeyById[loteId] = lanceData.key;
        self.atualizaLance(lotes, lanceData.val(), loteId);
      });
    });

    thisP.lotesLanceReference.forEach(function (ref) {
      ref.on("child_removed", function (dataRemoved) {
        const loteId = dataRemoved.val().lote_id;
        const nextCount = Math.max((self.loteCountById[loteId] || 0) - 1, 0);

        self.loteCountById[loteId] = nextCount;
        self.atualizaCountLances(lotes, {
          count_lances: nextCount,
          lote_id: loteId
        });

        if (nextCount === 0) {
          self.loteUltimoLanceKeyById[loteId] = null;
          self.atualizaLance(lotes, {
            nm_apelido: null,
            vl: 0.0,
            lote_id: loteId
          });
          return;
        }

        self.recarregaUltimoLanceLote(lotes, loteId, ref);
      });
    });

    /* dt fechamento */
    thisP.lotesDtfechamentoReference.forEach(function (ref) {
      ref.on("value", function (loteData) {
        if (loteData.val()) {
          const data = loteData.val();
          self.atualizaDtFechamentoLote(
            data.lote_id || ref.key,
            data.dt_fechamento,
            lotes
          );
        } else {
          self.atualizaDtFechamentoLote(ref.key, null, lotes);
        }
      });
    });
  }

  atualizaLance(lotes, data, loteId = null) {
    const id = loteId || (data && data.lote_id);

    if (!data || !id) {
      return;
    }

    this.atualizaDadosLanceLote(id, data, lotes);
  }

  atualizaCountLances(lotes, data) {
    if (!data || !data.lote_id) {
      return;
    }

    this.atualizaCountLancesLote(data.lote_id, data.count_lances, lotes);
  }

  atualizaLanceLotePregao(data, loteIdPregao = null) {
    const thisP = this.objParent;
    const loteId = loteIdPregao ||
      (data && data.lote_id) ||
      (thisP.lote_em_pregao && thisP.lote_em_pregao.lote_id);

    if (!loteId) {
      return;
    }

    this.atualizaDadosLanceLote(loteId, data, thisP.lotes);
  }

  calculaQtdePaginas() {
    const thisP = this.objParent;

    if (thisP.lotesAcompanhar.length > 0) {
      thisP.paginator.pageCount = thisP.lotesAcompanhar.length;
      return;
    }

    const self = thisP;

    this.db.ref(`/lote/${thisP.leilaoId}`)
      .once("value")
      .then(function (data) {
        if (data.exists()) {
          const lotesLeialo = Object.values(data.val());

          self.paginator.countLote = Object.keys(lotesLeialo).length;

          let qtdePaginas = parseInt(self.paginator.countLote / self.numeroRegistrosPorPagina);
          if (self.paginator.countLote % self.numeroRegistrosPorPagina > 0) {
            qtdePaginas++;
          }
          self.paginator.pageCount = qtdePaginas;

        } else {
          self.paginator.countLote = 0;
          self.paginator.pageCount = 0;
        }
      })
  }

  tipoParcelamento(leilao_id, lote_id) {
    const thisP = this.objParent;

    this.limpaTipoParcelamentoReference();

    thisP.tipoParcelamentoReference = this.db.ref(`/lote/${leilao_id}/${lote_id}/bn_aceitelanceparceladolote`);
    thisP.tipoParcelamentoReference.on("value", (snapshot) => {
      thisP.tipoParcelamento = snapshot.val();
    }, (error) => {
      console.error("Erro no monitoramento em tempo real:", error);
    });
  }


  async registraLotePregao() {
    const thisP = this.objParent;
    const self = thisP;

    this.limpaLotePregaoAtualReference();

    thisP.leilaoReference = this.db.ref(`/leilao/${thisP.leilaoId}`);
    await new Promise(resolve => {
      thisP.leilaoReference.on("value", function (data) {
        const leilao = data.val();
        if (leilao) {
          self.leilao = leilao;
        } else {
          self.leilao = Object.assign({}, self.leilao || {}, {
            id: self.leilao && self.leilao.id ? self.leilao.id : thisP.leilaoId,
          });
        }
        resolve();
      });
    });

    thisP.lotePregaoAtualReference = this.db.ref(`/geral/${thisP.leilaoId}/lote_id_pregao`);
    thisP.lotePregaoAtualReference.on("value", function (ret) {
      self.lote_id_pregao = ret.val();
      self.actionSeguir();
    });
  }

  determinaLotesAcompanhar(l) {
    const thisP = this.objParent;
    const lacompanhar = [];
    while (l.length > 0) {
      lacompanhar.push(l.splice(0, thisP.numeroRegistrosPorPagina));
    }
    thisP.lotesAcompanhar = lacompanhar;
  }

  filtrarAction() {
    const thisP = this.objParent;
    const hostName = location.protocol + "//" + window.HOSTNAME;

    thisP.$vs.loading({
      background: "#fff",
      color: "#67302B"
    });

    fetch(`${hostName}/leilao/filtro-id/leilao_id/${thisP.leilaoId}?${thisP.parametrosFiltro}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then(response => {
        if (response.length <= 0) {
          thisP.naoEncomtrado = true;
          thisP.loadingPage = false;
          thisP.$vs.loading.close();
          return false;
        }

        if (response.status == "nao_filtrar") {
          // sem filtros
          thisP.lotesAcompanhar = [];
          thisP.paginaAtual = 1;
          this.calculaQtdePaginas();
          this.refreshLotesListagem();
          thisP.$vs.loading.close();
          return;
        }

        thisP.filtros = response.filtros;

        const l = response.lotes.map(function (ll) {
          return ll.lote_id;
        });
        this.determinaLotesAcompanhar(l);
        this.calculaQtdePaginas();

        // voltar para primeira pagina apos o filtro
        this.refreshLotesListagem();
        thisP.$vs.loading.close();
      });
  }

  configuraFavoritos(_self) {
    const thisP = this.objParent;
    thisP.lotes.forEach(function (lote) {
      if (
        thisP.usuario &&
        thisP.usuario.interesse &&
        thisP.usuario.interesse.indexOf(lote.lote_id) >= 0
      ) {
        lote.is_favorito = true;
      } else {
        lote.is_favorito = false;
      }
    });

    if (_self) {
      _self.$forceUpdate();
    }
  }

  configuraVisitas() {
    const thisP = this.objParent;
    const lotes = thisP.lotes;
    if (!lotes || Object.keys(lotes).length === 0) {
      return;
    }
    thisP.visitas.forEach(v => {
      const idx = lotes.findIndex(l => l.lote_id == v.lote_id);
      if (idx > -1) {
        thisP.lotes[idx].nu_visitas = v.nu_visitas;
        thisP.lotes[idx].rating = v.rating;
      }
    });
  }

  /* lotes agrupados -> Busca e Categoria */
  refreshLotesAgrupados(lotes) {
    if (!lotes || Object.keys(lotes).length === 0) {
      return;
    }
    const thisP = this.objParent;
    const self = this;

    thisP.lotesAgrupados.map((item, i) => {
      item.lotes.forEach(function (l) {
        const idx = lotes.findIndex(x => x.lote_id == l.lote_id);

        if (idx === -1) {
          return;
        }

        l.statuslote = lotes[idx].statuslote;
        l.statusLoteBg = lotes[idx].statusLoteBg;
        l.vl_lance = lotes[idx].vl_lance;
        l.vl_lance_sugerido = lotes[idx].vl_lance_sugerido;
        self.setReactiveField(l, 'dt_fechamento', lotes[idx].dt_fechamento || null);
      });
    });
  }

  notificationLeilao(leilao) {
    if (leilao.id == 23287 || leilao.leilao_id_primeiroleilao == 23287) {
      return true;
    }
    return false;
  }

  moneyToCents(input) {
    if (input == null || input === '') return 0;
    if (typeof input === 'number' && Number.isFinite(input)) return Math.round(input * 100);

    let s = String(input).trim().replace(/[^\d.,-]/g, ''); // mantém dígitos, vírgula, ponto e sinal

    const negative = s.startsWith('-');
    s = s.replace(/-/g, '');

    const hasSeparator = s.includes(',') || s.includes('.');

    if (!hasSeparator) {
      const cents = parseInt(s, 10);
      return negative ? -cents : cents;
    }

    const sepIndex = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    const intPart = s.slice(0, sepIndex).replace(/[.,]/g, '');
    const decPart = (s.slice(sepIndex + 1).replace(/[^\d]/g, '') + '00').slice(0, 2);

    const cents =
      parseInt(intPart || '0', 10) * 100 +
      parseInt(decPart || '0', 10);

    return negative ? -cents : cents;
  }

  async exibirParcelamento(
    valor,
    nu_intervaloparcelaslote,
    bn_aceitelanceparcelado,
    bn_aceitelanceparceladolote,
    vl_liberaparcelamento
  ) {
    const aceitaParcelado = Boolean(bn_aceitelanceparcelado || bn_aceitelanceparceladolote);
    if (!aceitaParcelado) return false;

    if (![6].includes(Number(nu_intervaloparcelaslote))) {
      const lanceCents = this.moneyToCents(valor);
      const minimoCents = this.moneyToCents(vl_liberaparcelamento);
      return minimoCents === 0 || lanceCents >= minimoCents;
    }

    return true;
  }

  bloquearBotaoEnvio(texto = 'Enviando...', selector = '.btn-modal-enviar') {
    const btn = document.querySelector(selector);

    if (!btn) return;

    btn.disabled = true;
    btn.innerText = texto;
  }
}

window
  .saladisputa = SalaDisputa;



// WEBPACK FOOTER //
// ./src/assets/js/saladisputa.js